import { Select } from "antd";
import { FC } from "react";

const SelectTransactionActionField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="adivery" >تبلیغ ادیوری</Select.Option>
      <Select.Option key="creditPack" >خرید پکیج</Select.Option>
      <Select.Option key="order" >ثبت سفارش</Select.Option>
      <Select.Option key="voted" >نظرسنجی</Select.Option>
      <Select.Option key="cart" >کارت به کارت</Select.Option>
      <Select.Option key="refunded" >بازگشت وجه  </Select.Option>
      <Select.Option key="init" >انتقال داده ها</Select.Option>
      <Select.Option key="register" >ثبت نام</Select.Option>
    </Select>
  )
}

export default SelectTransactionActionField
